import { guid } from '../../Config/Helpers';

export class DeviceRow {
    constructor(rowName, rowType, rowData, disclosureIndicator, subsection, identifier, path, editable = false) {
        this.rowName = rowName;
        this.rowType = rowType;
        this.rowData = rowData;
        this.disclosureIndicator = disclosureIndicator
        this.subsection = subsection
        this.uid = guid()
        this.identifier = identifier;
        this.path = path
        this.edited = false;
        this.editable = editable;
        this.dataKey = guid();
    }
}